const swiper = new Swiper(".swiper", {
    // loop: true,
    loopedSlides: 2,
    spaceBetween: 30,
    touchRatio: 1.5,
    simulateTouch: true,
    grabCursor: true,
    // freeMode: true,
    allowTouchMove: true,
    // freeModeSticky: true,
    // freeModeMomentum: false,
    preventIntercationOnTransition: true,
    touchEventsTarget: 'container',
    effect: 'slide',
    slidesPerView: 'auto',
    // breakpoints: {
    //     // ウィンドウサイズが320px以下
    //     320: {
    //       slidesPerView: 1,
    //       spaceBetween: 10
    //     },
    //     // ウィンドウサイズが480px以下
    //     480: {
    //       slidesPerView: 2,
    //       spaceBetween: 20
    //     },
    //     // ウィンドウサイズが640px以下
    //     640: {
    //       slidesPerView: 3,
    //       spaceBetween: 30
    //     }
    // },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

});

jQuery(function ($) {
    var webStorage = function () {
        if (sessionStorage.getItem('access')) {
          /*2回目以降アクセス時の処理*/
          $('#loader-bg').addClass('is-active');
        } else {
          /*初回アクセス時の処理*/
          sessionStorage.setItem('access', 'true'); // sessionStorageにデータを保存
          $('#loader').addClass('is-active');
          setTimeout(function () {
            // ローディングを数秒後に非表示にする
            $('#loader-bg').fadeOut(600);
            $('#loader').removeClass('is-active');
          }, 1800); // ローディングを表示する時間
        }
      }
      webStorage();


    const header = $('.header, .l-header, .c-drawer-icon, .c-drawer-content__logo');
    $(window).scroll(function () {
        if ($(this).scrollTop() >= 10) {
        header.addClass('-js-change');
      } else {
        header.removeClass('-js-change');
      }
    });


    $('.-js-nav-service, .-js-hover').mouseover(function () {
        $(".l-header--b").removeClass("-js-hover");

    }).mouseout(function(){
        $(".l-header--b").addClass("-js-hover");
    }
    );
    
    $('.-js-nav-service, .-js-hover').mouseover(function () {
        $(".c-nav__group").addClass("-js-block");
    }).mouseout(function(){
        $(".c-nav__group").removeClass("-js-block");
    }
    );
    
    $('.-js-nav-item').hover(function () {
        $(".l-header--b").addClass("-js-hover");
    });

    $('.-js-nav-service, .-js-hover').mouseover(function () {
            $(".l-header").addClass("-js-none");
        }).mouseout(function(){
            $(".l-header").removeClass("-js-none");
        }
    );

    $('.-js-nav-service, .-js-hover').mouseover(function () {
            $(".c-nav__bg").addClass("-js-block");
        }).mouseout(function(){
            $(".c-nav__bg").removeClass("-js-block");
        }
    );

    $(".top-service__item").hover(function () {
        $(this).children(".c-circle-btn01").addClass("js-active");
    },function () {
        $(this).children(".c-circle-btn01").removeClass("js-active");
    });

    $(".c-circle-btn02").hover(function () {
        $(this).children(".c-circle-btn02__icon").addClass("js-active");
    },function () {
        $(this).children(".c-circle-btn02__icon").removeClass("js-active");
    });

    $(".cta__wrap").hover(function () {
        $(this).children(".c-circle-btn01").addClass("js-active");
    },function () {
        $(this).children(".c-circle-btn01").removeClass("js-active");
    });

    $('.c-drawer-icon').on('click', function(e) {
        e.preventDefault();

        $('.c-drawer-icon').toggleClass('is-active');
        $('.c-drawer-content').toggleClass('is-active');
        $('.c-drawer-background').toggleClass('is-active');

        return false;
    });

    $('.js-toggle').on('click', function(){
        $(this).children(".c-drawer-content__sub-list").slideToggle();
        $(this).find('.c-drawer-content__bar2').toggleClass('js-open');
    });

    var Target = $('.is-empty');
    $(Target).on('change', function () {
        if ($(Target).val() !== "") {
            $(this).removeClass('is-empty');
        } else {
            $(this).addClass('is-empty');
        }
    });
});